<!--  -->
<template>
  <div>
    <div style="margin-bottom:20px">
      <el-select v-model="value" placeholder="请选择处理结果">
        <el-option
          v-for="itemr in options"
          :key="itemr.value"
          :label="itemr.label"
          :value="itemr.value"
        />
      </el-select>
    </div>

    <el-button type="primary" @click="sumbitr">确定</el-button>
  </div>
</template>

<script>
import { editProcessingStatus } from '@/api/officialaccount.js'
export default {
  components: {},
  data() {
    return {
      options: [{
        value: 2,
        label: '处理完成'
      }, {
        value: 3,
        label: '不处理'
      }],
      value: null,
      item: {}
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(item) {
      this.item = {}
      this.item = item
    },
    async sumbitr() {
      if (this.value === null) {
        this.$message.error('请选择处理类型')
        return
      }
      const data = await editProcessingStatus({
        id: this.item.id,
        // employee_no: this.item.employee_no,
        // external_user_id: this.item.external_user_id,
        processing_status: this.value
      })
      console.log('data', data)
      this.$emit('updata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
